<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                   <sidebar></sidebar> 
                </el-aside>
                <el-main>
                    <comentTitle  :comentTitle="comentTitle1" :comentText="comentText1" @onEitd="goEdit()"></comentTitle>
                    <companySide class="mt-20" :isButton ="isButton" ></companySide>
                    <div class="mt-30">
                         <!--公司简介-->
                        <contTitle  :obj="obj" :contTitle="contTitle1"></contTitle>                   
                        <div class="today" v-html="company.detail"></div>

                        <!--企业资质-->
                        <contTitle  class="mt-30" :obj="obj" :contTitle="contTitle2"></contTitle>
                           <div class="mt-20" v-if="list != null">
                            <el-carousel
                                :interval="4000"
                                type="card"
                                :autoplay="false"
                                height="200px"
                                width="800px"
                                indicator-position="none"
                            >
                                <el-carousel-item v-for="(item, index) in list" :key="index">
                                <viewer>
                                    <img class="viewer_img" :src="item.url" />
                                </viewer>
                                </el-carousel-item>
                            </el-carousel>
                           </div>
                         <!--企业宣传片-->
                        <div v-if="videoUrl">
                            <contTitle class="mt-20" :obj="obj" :contTitle="contTitle3"></contTitle>
                            <div class="foot_img mt-20"> 
                                <videoPlayer :videoUrl="videoUrl"></videoPlayer>
                                <div class="video_text">{{company.publicizeVideoDesc}}</div>		
                             </div>
                        </div>

                    </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import sidebar from '../../common/sidebar'
import companySide from '../../common/companySide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import paletteBar from '../../common/paletteBar'
import contTitle from '../../common/contTitle'
import comentTitle from '../../common/comentTitle'
import pictureLeftList from '../../components/pictureLeftList'
import videoPlayer from '../../components/videoPlayer'
export default {
  components:{
      sidebar,companySide,commBanner,titleHead,paletteBar,contTitle,comentTitle,pictureLeftList,videoPlayer
  }, 
  data(){
      return{
        headTitle:'企业咨询',
        contTitle3:'企业宣传片',
        contTitle1:"公司简介",
        contTitle2:'企业资质',
        comentTitle1:'企业基本信息',
        comentText1:'编辑企业信息  >',
        comentTitle2:'公司简介',
        comentText2:'更多  >',
        comentTitle3:'企业资质',
        comentText3:'更多  >',
        obj:{
           title:'企业信息',   
           isShow:false, 
           isColor:false,
           roleType:3,
           personalType:9
        },
        company:{},
        list:[],
        isButton:false,
        videoUrl:''
      }
  },
  created(){
     this.company = this.$store.state.user.userInfo.data;
     this.videoUrl = this.company.publicizeVideo;
     this.list = JSON.parse(this.company.companyQualification);
  },
  methods:{
      //编辑个人信息
      goEdit(){
        this.$router.push('/personal_information')
      }
  } 
}
</script>
<style scoped>
/* .el-aside{
    height: 930px;
} */
.mt-20{
    margin-top: 20px;
}
.mt-30{
    margin-top: 30px;
}
.today{
    text-align: left;
    margin-top: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;  
    line-height: 24px;
    overflow: auto;
    max-height: 500px;
}
.today >>> span{
	background-color: #ffffff !important;
}
.today>>>img{
   width: 100%;
   height: 300px;
   padding-bottom: 15px;
}
.natural {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.natural_img{
    width: 195px;
    margin-right: 20px;
}
.natural_imgs{
    height: 169px;
}
.foot_img{
  width: 100%;
  /* height: 370px; */
}
.foot_img >>> video{
   width: 100%;
   height: 100%;
   object-fit: fill;
}
.viewer_img{
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.video_text{
  margin-top: 10px;
  text-align: left;
  font-size: 14px;
  height: 80px;
  color: #666666;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/view/company/corporate_news.vue